<template>
  <div>
    <div class="router-header flex flex-wrap items-center mb-3">
      <div
        class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
      >
        <h4 class="mb-2">Finally</h4>
        <div class="mt-2 mb-1">
          Leave a note to your coach (Optional)
        </div>
      </div>
    </div>

    <div class="m-2 p-2 note-to-coach">
      <div class="pb-2 borderBottom">
        <div contenteditable="true" @input="noteToCoach">
          Type your message here...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoteToCoach",
  data() {
    return {};
  },
  methods: {
    noteToCoach(e) {
      console.log(e.target.innerText);
    }
  }
};
</script>

<style scoped>
.borderBottom {
  border-bottom: 1px solid black;
}

.note-to-coach{
  margin-top: 5rem! important;
  padding: 2rem! important;
  text-align: center;
}
</style>
